import React, { Fragment } from "react";
import * as s from "./CreateProject.styles";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../../../components/shared/inputs/FormikControl";
import Spinner from "../../../components/shared/spinner/Spinner";
// images
import logo from "../../../assets/images/logo.png";

// reducer
import * as actions from "../../../store/actions/index";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useHistory } from "react-router-dom";

const CreateProject = () => {
  let { clientId } = useParams();
  let dispatch = useDispatch();
  const history = useHistory();
  // console.log(clientId);

  const initialValues = {
    name: "",
    type: "",
    budget: "",
    startDate: "",
    timeLine: "",
    streetAddress: "",
    city: "",
    state: "",
    zip: "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Required"),
    type: Yup.string().required("Required"),
    budget: Yup.number().required("Required"),
    startDate: Yup.string().required("Required"),
    timeLine: Yup.number().required("Required"),
    streetAddress: Yup.string().required("Required"),
    city: Yup.string().required("Required"),
    state: Yup.string().required("Required"),
    zip: Yup.string().required("Required"),
  });

  const onSubmit = (data) => {
    console.log(data);
    dispatch(
      actions.createClientProject(clientId, data, () => history.goBack())
    );
  };

  const createLoading = useSelector((state) => state.forProjects.loading);
  console.log(createLoading);
  return (
    <s.ScreenContainer>
      {!createLoading ? (
        <Fragment>
          <s.Container>
            <s.LogoContainer>
              <s.LogoImage src={logo} />
            </s.LogoContainer>

            <s.FormContainer>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {(formik) => {
                  return (
                    <Form>
                      <s.H1>Create new project</s.H1>
                      <s.Inputs>
                        <s.InputContainer>
                          <FormikControl
                            control="input"
                            // control='chakraInput'
                            type="text"
                            name="name"
                            placeholder="PROJECT NAME"
                          />

                          <FormikControl
                            control="input"
                            // control='chakraInput'
                            type="text"
                            name="type"
                            placeholder="PROJECT TYPE"
                          />
                        </s.InputContainer>

                        <s.InputContainer3>
                          <FormikControl
                            control="input"
                            // control='chakraInput'
                            type="number"
                            name="budget"
                            placeholder="BUDGET"
                          />

                          <FormikControl
                            control="input"
                            type="date"
                            name="startDate"
                            placeholder="START DATE (MM/DD/YY)"
                          />

                          <FormikControl
                            control="input"
                            type="text"
                            name="timeLine"
                            placeholder="TIME LINE"
                          />
                        </s.InputContainer3>

                        <s.H3>Address (if applicable)</s.H3>
                        <s.InputContainer1>
                          <FormikControl
                            control="input"
                            type="text"
                            name="streetAddress"
                            placeholder="STREET ADRESS"
                          />
                        </s.InputContainer1>
                        <s.InputContainer3>
                          <FormikControl
                            control="input"
                            type="text"
                            name="city"
                            placeholder="CITY"
                          />

                          <FormikControl
                            control="input"
                            type="text"
                            name="state"
                            placeholder="STATE"
                          />

                          <FormikControl
                            control="input"
                            type="text"
                            name="zip"
                            placeholder="ZIP"
                          />
                        </s.InputContainer3>

                        <s.Div>
                          <s.CreateBtn
                            type="submit"
                            disabled={!formik.isValid}
                            onClick={formik.handleSubmit}
                          >
                            Create
                          </s.CreateBtn>
                        </s.Div>
                      </s.Inputs>
                    </Form>
                  );
                }}
              </Formik>
            </s.FormContainer>
          </s.Container>
        </Fragment>
      ) : (
        <s.SpinnerContainer>
          <Spinner />
        </s.SpinnerContainer>
      )}
    </s.ScreenContainer>
  );
};

export default CreateProject;
